import React, { Suspense } from "react";
import { BrowserRouter } from 'react-router-dom'
import { RegistroReclamaciones } from "./pages/RegistroReclamaciones";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const App = () => {
    return (
        <>
                    <Suspense fallback={<h1>Cargando...</h1>}>
                        <BrowserRouter basename={process.env.REACT_APP_SUB_DIRECTORY}>
                            <RegistroReclamaciones />
                        </BrowserRouter>
                    </Suspense>
                    <ToastContainer></ToastContainer>

        </>
    )
}
